import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../../assets/images/BG1.jpg";
import logoImage from "../../assets/images/Red-Rhino-Logo.png";
import { validateEmail } from "../../utils/validationUtils"; // Import the utility
import { AuthApiService } from "../../service/authService";
import {
  headingStyles,
  descriptionStyles,
  inputContainerStyles,
  inputLabelStyles,
  textFieldStyles,
  formContainer,
} from "./ForgotPassword.styles";
import { styles } from "../loginScreen/LoginScreen.styles";
import useIsMobile from "../../common/mobileVersion/useIsMobile";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [orgId, setOrgId] = useState("");

  useEffect(() => {
    const Organization = localStorage.getItem("orgId") ?? "";
    setOrgId(Organization);
  }, []);

  const handleContinue = async () => {
    const validationError = validateEmail(email);

    if (validationError) {
      alert(validationError);
      return;
    }

    try {
      const result = await AuthApiService.forgotPassword(email);
      console.log("result: ", result);
    } catch (err) {
      console.log("error", err);
    }

    // Navigate to the Set New Password page
    navigate(`/${orgId}/confirmation`, {
      state: {
        description:
          "Thank you. Please check your inbox for the password reset link to proceed.",
        isForgotPasswordFlow: false,
      },
    });
  };

  return (
    <Box sx={styles.container(backgroundImage)}>
      <Box sx={styles.logoContainer(isMobile)}>
        <Box
          component="img"
          src={logoImage}
          alt="Logo"
          sx={styles.logo(isMobile)}
        />
      </Box>
      <Box sx={formContainer(isMobile)}>
        <Typography variant="h3" gutterBottom sx={headingStyles(isMobile)}>
          Forgot Password
        </Typography>
        <Typography variant="body2" sx={descriptionStyles(isMobile)}>
          Enter your email address for verification. A password reset link will
          be sent to the registered email ID.
        </Typography>
        <Box sx={inputContainerStyles}>
          <Typography variant="body1" sx={inputLabelStyles}>
            Email
          </Typography>

          {/* Email Field */}
          <TextField
            type="email"
            placeholder="username@test.com"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={textFieldStyles}
          />

          {/* Continue Button */}
          <Button
            variant="contained"
            fullWidth
            onClick={handleContinue}
            sx={styles.loginButton(isMobile)}
          >
            CONTINUE
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
